
export default {
    name: 'TrashNodeModal',
    props: {
        node: {
            type: Object,
            default: null
        }
    },
    methods: {
        trashNode () {
            this.$emit('trash-node', this.node)
        }
    }
}
